import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Row, Col, Card, Form, Input, Button,
	Select, Switch, message, Alert, Spin, Avatar, Tag, Divider,
	Typography,
} from 'antd';
import {
	UserOutlined, LockOutlined, PhoneOutlined, IdcardOutlined,
	SaveOutlined, HomeOutlined, TeamOutlined, BankOutlined,
	EnvironmentOutlined, SafetyOutlined, SettingOutlined,
	CloseCircleOutlined, ApartmentOutlined, SolutionOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig, extractResult } from '../../store/actions';
import { Helmet } from 'react-helmet';
import Config from '../../Config';
import Cookies from 'js-cookie';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title: 'Form Pegawai',
	apiUrl: {
		preview:   'pegawai/api/pegawai/',
		jabatan:   'pegawai/api/jabatan/',
		kabupaten: 'master/api/kabupaten/',
		bidang:    'pegawai/api/bidang/',
		upt:       'pegawai/api/upt/',
	},
	pageUrl: { data: '/admin/pegawai/' },
};

const config = new Config();

const LEVEL_MAP = {
	1: { label: 'Superadmin', color: '#f5222d' },
	2: { label: 'Admin',      color: '#1890ff' },
	3: { label: 'User',       color: '#52c41a' },
};

const sectionCard = (title, icon, color, children) => (
	<Card
		style={{
			borderRadius: 14,
			boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
			overflow: 'hidden',
			marginBottom: 20,
		}}
		bodyStyle={{ padding: 0 }}
	>
		<div style={{
			padding: '14px 24px',
			background: `linear-gradient(135deg, ${color}22, ${color}11)`,
			borderBottom: `2px solid ${color}33`,
			display: 'flex', alignItems: 'center', gap: 10,
		}}>
			<span style={{ color, fontSize: 18 }}>{icon}</span>
			<Text strong style={{ fontSize: 15, color: '#222' }}>{title}</Text>
		</div>
		<div style={{ padding: '24px 28px' }}>{children}</div>
	</Card>
);

class FormPegawai extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errComponent: false,
			errTitle: '',
			errMsg: '',
			loadingButton: false,
			aksi: 'tambah',
			method: 'post',
			idLama: '',

			listJabatan: [],    loadingJabatan: false,
			listBidang: [],     loadingBidang: false,
			listKabupaten: [],  loadingKabupaten: false,
			listUpt: [],        loadingUpt: false,

			selectedKabupaten: null,

			is_notice: false,
			is_pns_value: null,       // null=belum pilih, true=PNS, false=Non-PNS
			previewNama: '',
			previewUsername: '',
			previewJabatan: '',
			previewLevel: 3,

			usernameStatus: 'idle',   // 'idle' | 'checking' | 'available' | 'taken' | 'invalid'
			usernameSuggestions: [],
			usernameError: '',
		};
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this.loadMasterList();
	}

	async preview(id) {
		message.loading({ content: 'Memuat data...', duration: 0, key: 'toast' });
		this.props.ajaxViewHandler('get', configClass.apiUrl.preview + id)
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				if (isSuccess) {
					this.setState({
						aksi: 'edit',
						method: 'put',
						idLama: id + '/',
						is_notice: data.is_notice || false,
						is_pns_value: data.is_pns !== undefined ? data.is_pns : null,
						previewNama: data.nama || '',
						previewUsername: data.username || '',
						previewJabatan: data.jabatan_nama || '',
						previewLevel: data.level_user || 3,
						selectedKabupaten: data.kabupaten || null,
					});
					// Load UPT dulu berdasarkan kabupaten, baru set semua nilai form
					this.loadUptByKabupaten(data.kabupaten, () => {
						this.formRef.current.setFieldsValue(data);
						this.formRef.current.setFieldsValue({ is_notice: data.is_notice || false });
						message.destroy();
					});
				} else {
					this.setState({ errTitle: 'Gagal memuat data', errMsg: data });
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
			})
			.catch(() => message.error({ content: 'Gagal request data', duration: 2, key: 'toast' }));
	}

	handleSubmit = (values) => {
		if (this.state.aksi === 'tambah' && this.state.usernameStatus === 'taken') {
			message.error('Username sudah digunakan, pilih username lain terlebih dahulu.');
			return;
		}
		if (this.state.aksi === 'tambah' && this.state.usernameStatus === 'invalid') {
			message.error(this.state.usernameError || 'Username tidak valid.');
			return;
		}
		// Non-PNS → isi NIP dengan '-' agar tidak null di database
		if (this.state.is_pns_value === false) {
			values.nip = '-';
		}
		this.postData(values);
	};

	async postData(datas) {
		message.loading({ content: 'Menyimpan...', key: 'toast' });
		this.setState({ loadingButton: true });
		this.props.ajaxHandler(this.state.method, configClass.apiUrl.preview + this.state.idLama, datas, false, true)
			.then((action) => {
				this.setState({ loadingButton: false });
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					message.success({ content: 'Data berhasil disimpan', duration: 2, key: 'toast' });
				} else {
					const errTitle = 'Gagal menyimpan data';
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({ errTitle, errMsg: responseMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'Kesalahan pengiriman data', duration: 2, key: 'toast' });
			});
	}

	loadMasterList() {
		const rules = [
			{
				destination: { stateProgressName: 'loadingJabatan', endPoint: configClass.apiUrl.jabatan, stateDestination: 'listJabatan' },
				nextDestination: { stateProgressName: 'loadingBidang', endPoint: configClass.apiUrl.bidang, stateDestination: 'listBidang', next: null },
			},
			{
				destination: { stateProgressName: 'loadingKabupaten', endPoint: configClass.apiUrl.kabupaten, stateDestination: 'listKabupaten' },
				nextDestination: null,
			},
		];
		this.setState({ errComponent: false });
		rules.forEach((item, index) => this.getMasterList(item, index === rules.length - 1));
	}

	loadUptByKabupaten(kabupatenId, callback = null) {
		if (!kabupatenId) {
			this.setState({ listUpt: [] }, callback);
			return;
		}
		this.setState({ loadingUpt: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.upt + '?kabupaten=' + kabupatenId)
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				const results = isSuccess
					? (data.results !== undefined ? data.results : (Array.isArray(data) ? data : []))
					: [];
				this.setState({ listUpt: results, loadingUpt: false }, callback);
			})
			.catch(() => {
				this.setState({ loadingUpt: false }, callback);
			});
	}

	handleKabupatenChange = (val) => {
		this.setState({ selectedKabupaten: val || null });
		this.formRef.current.setFieldsValue({ upt: undefined });
		this.loadUptByKabupaten(val);
	};

	async getMasterList(rule, isFinal = false) {
		const { destination, nextDestination } = rule;
		this.setState({ [destination.stateProgressName]: true });
		this.props.ajaxViewHandler('get', destination.endPoint)
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				if (isSuccess) {
					if (data.count !== undefined) {
						const oldState = this.state[destination.stateDestination];
						let newState;
						if (oldState.length === 0) {
							newState = data;
						} else if (destination.stateProgressName.includes('_searching')) {
							newState = data;
						} else {
							newState = {
								count: data.count, next: data.next, previous: data.previous,
								results: [...oldState.results, ...data.results],
							};
						}
						this.setState({ [destination.stateDestination]: newState });
					} else if (data.results !== undefined) {
						this.setState({ [destination.stateDestination]: data.results });
					} else {
						this.setState({ [destination.stateDestination]: Array.isArray(data) ? data : [data] });
					}
					if (isFinal && this.props.match.params.id !== undefined) {
						this.preview(this.props.match.params.id);
					}
				} else {
					this.setState({ errComponent: true });
				}
				this.setState({ [destination.stateProgressName]: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request data master', duration: 2, key: 'toast' });
				this.setState({ [destination.stateProgressName]: false });
			});
		if (nextDestination) {
			this.getMasterList({ destination: nextDestination, nextDestination: nextDestination.next });
		}
	}

	generateSelect(stateName, url, key, value, keyDisplay = '', extraSelectProps = {}, extraParams = '') {
		const loading = this.state['loading' + stateName];
		const list    = this.state['list' + stateName];
		if (loading) return <Spin size="small" />;

		const buildSearchUrl = (searchVal) => {
			const parts = [extraParams, 'search=' + searchVal].filter(Boolean).join('&');
			return url + '?' + parts;
		};

		return (
			<Select
				showSearch
				placeholder={'Cari / Pilih ' + stateName}
				optionFilterProp="children"
				allowClear
				size="large"
				style={{ width: '100%', borderRadius: 8 }}
				{...extraSelectProps}
				onSearch={(val) => {
					this.getMasterList({
						destination: {
							stateProgressName: 'loading' + stateName + '_searching',
							endPoint: buildSearchUrl(val),
							stateDestination: 'list' + stateName,
						},
						nextDestination: null,
					});
				}}
				onPopupScroll={(e) => {
					e.persist();
					const target = e.target;
					if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
						const next = list.next;
						if (next) {
							this.getMasterList({
								destination: {
									stateProgressName: 'loading' + stateName + 'Paging',
									endPoint: next,
									stateDestination: 'list' + stateName,
								},
								nextDestination: null,
							});
						}
					}
				}}
			>
				{this.state['loading' + stateName + '_searching'] && (
					<Select.Option value=""><Spin size="small" /></Select.Option>
				)}
				{(list.count !== undefined ? list.results : list).map((item) => (
					<Select.Option key={item[key]} value={item[key]}>
						{keyDisplay === '' ? `${item[key]} — ${item[value]}` : `${item[keyDisplay]} — ${item[value]}`}
					</Select.Option>
				))}
				{list.next && (
					<Select.Option value=""><Spin size="small" /></Select.Option>
				)}
			</Select>
		);
	}

	_inisial(nama) {
		if (!nama) return '?';
		return nama.split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase();
	}

	// Saran alternatif WAJIB tetap alfanumerik murni (samakan dgn USERNAME_REGEX
	// backend, be/pegawai/views.py) - dulu ada "_${yr}"/"_baru" yang justru
	// menyarankan format yang sekarang dilarang sendiri.
	_generateSuggestions(username) {
		const yr = new Date().getFullYear();
		return [
			`${username}1`,
			`${username}2`,
			`${username}${yr}`,
			`${username}123`,
			`${username}baru`,
		];
	}

	async checkUsername(username) {
		const trimmed = (username || '').trim();
		if (!trimmed) return;
		this.setState({ usernameStatus: 'checking', usernameSuggestions: [] });
		try {
			const baseUrl = process.env.REACT_APP_API_PATH;
			const token = Cookies.get(config.get_cookie_name());
			const res = await fetch(
				`${baseUrl}pegawai/api/pegawai/check_username/?username=${encodeURIComponent(trimmed)}`,
				{ headers: { Authorization: token || '' } }
			);
			const data = await res.json();
			if (data.error) {
				// Format tidak valid (mis. ada underscore/spasi/simbol) - beda
				// dari 'taken', jangan tawarkan saran (nambah suffix ke username
				// yang formatnya sendiri sudah salah tidak menyelesaikan apa-apa).
				this.setState({ usernameStatus: 'invalid', usernameSuggestions: [], usernameError: data.error });
			} else if (data.exists) {
				this.setState({
					usernameStatus: 'taken',
					usernameSuggestions: this._generateSuggestions(trimmed),
				});
			} else {
				this.setState({ usernameStatus: 'available', usernameSuggestions: [] });
			}
		} catch {
			this.setState({ usernameStatus: 'idle' });
		}
	}

	useSuggestion(suggestion) {
		this.formRef.current.setFieldsValue({ username: suggestion });
		this.checkUsername(suggestion);
	}

	render() {
		if (this.props.isRedirect) return <Redirect to={configClass.pageUrl.data} />;

		const {
			loadingButton, errMsg, errTitle, aksi, is_notice,
			previewNama, previewUsername, previewJabatan, previewLevel,
			usernameStatus, usernameSuggestions, usernameError,
		} = this.state;
		const is_pns_value = this.state.is_pns_value;
		const isEdit = aksi === 'edit';
		const levelInfo = LEVEL_MAP[previewLevel] || LEVEL_MAP[3];

		const gradientBanner = isEdit
			? 'linear-gradient(135deg, #1890ff, #722ed1)'
			: 'linear-gradient(135deg, #13c2c2, #1890ff)';

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.form-pegawai-wrap .ant-input,
						.form-pegawai-wrap .ant-input-password input,
						.form-pegawai-wrap .ant-input-affix-wrapper input,
						.form-pegawai-wrap .ant-select-selection-search-input,
						.form-pegawai-wrap .ant-select-selection-item,
						.form-pegawai-wrap .ant-select-item-option-content {
							text-transform: none !important;
						}
						.form-pegawai-wrap .ant-input-lg,
						.form-pegawai-wrap .ant-input-affix-wrapper-lg,
						.form-pegawai-wrap .ant-select-lg .ant-select-selector {
							border-radius: 8px !important;
						}
						.form-pegawai-wrap .ant-form-item-label > label {
							font-weight: 600;
							color: #444;
						}
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Form
					layout="vertical"
					name="fdata"
					onFinish={this.handleSubmit}
					ref={this.formRef}
					className="form-pegawai-wrap"
				>
					<Row gutter={[20, 0]}>

						{/* ===== KOLOM KIRI — Avatar Card ===== */}
						<Col xs={24} md={7}>
							<Card
								style={{
									borderRadius: 14,
									boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
									overflow: 'hidden',
									marginBottom: 20,
									position: 'sticky',
									top: 20,
								}}
								bodyStyle={{ padding: 0 }}
							>
								{/* Banner gradient */}
								<div style={{
									background: gradientBanner,
									padding: '36px 20px 60px',
									textAlign: 'center',
								}}>
									<Avatar
										size={90}
										icon={<UserOutlined />}
										style={{
											background: 'rgba(255,255,255,0.25)',
											fontSize: 34,
											fontWeight: 700,
											color: '#fff',
											border: '3px solid rgba(255,255,255,0.5)',
										}}
									>
										{isEdit ? this._inisial(previewNama) : <UserOutlined />}
									</Avatar>
								</div>

								{/* Info summary */}
								<div style={{
									padding: '0 24px 24px',
									marginTop: -36,
									textAlign: 'center',
								}}>
									<div style={{
										background: '#fff',
										borderRadius: 12,
										padding: '16px 20px',
										boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
									}}>
										{isEdit ? (
											<>
												<div style={{ fontWeight: 700, fontSize: 16, color: '#222', lineHeight: 1.3 }}>
													{previewNama || '—'}
												</div>
												<div style={{ color: '#888', fontSize: 13, marginTop: 4 }}>
													@{previewUsername || '—'}
												</div>
												<div style={{ marginTop: 10 }}>
													<Tag color={levelInfo.color} style={{ borderRadius: 20, padding: '2px 12px', fontWeight: 600 }}>
														{levelInfo.label}
													</Tag>
												</div>
												{previewJabatan && (
													<div style={{ marginTop: 10, fontSize: 12, color: '#666', background: '#f5f5f5', borderRadius: 8, padding: '6px 10px' }}>
														<ApartmentOutlined /> {previewJabatan}
													</div>
												)}
											</>
										) : (
											<>
												<div style={{ fontWeight: 700, fontSize: 15, color: '#222' }}>Pegawai Baru</div>
												<div style={{ color: '#aaa', fontSize: 13, marginTop: 4 }}>Lengkapi formulir di samping</div>
												<div style={{ marginTop: 10 }}>
													<Tag color="#13c2c2" style={{ borderRadius: 20, padding: '2px 12px' }}>Tambah Data</Tag>
												</div>
											</>
										)}
									</div>

									<Divider style={{ margin: '20px 0 16px' }} />

									<div style={{ textAlign: 'left' }}>
										{[
											{ icon: <TeamOutlined />, label: 'Status', value: isEdit ? (this.state.previewLevel === 1 ? 'Superadmin' : this.state.previewLevel === 2 ? 'Admin' : 'User') : '—' },
											{ icon: <SolutionOutlined />, label: 'Jabatan', value: previewJabatan || '—' },
										].map(item => (
											<div key={item.label} style={{
												display: 'flex', alignItems: 'center', gap: 10,
												padding: '8px 0',
												borderBottom: '1px solid #f5f5f5',
											}}>
												<span style={{ color: '#1890ff', fontSize: 15, flexShrink: 0 }}>{item.icon}</span>
												<div>
													<div style={{ fontSize: 11, color: '#aaa' }}>{item.label}</div>
													<div style={{ fontSize: 13, fontWeight: 600, color: '#333' }}>{item.value}</div>
												</div>
											</div>
										))}
									</div>

									<div style={{ marginTop: 20, display: 'flex', gap: 8, flexDirection: 'column' }}>
										<Button
											type="primary"
											htmlType="submit"
											icon={<SaveOutlined />}
											size="large"
											loading={loadingButton}
											disabled={this.state.errComponent}
											style={{ borderRadius: 10, width: '100%', fontWeight: 600 }}
										>
											{isEdit ? 'Simpan Perubahan' : 'Tambah Pegawai'}
										</Button>
										<Link to={configClass.pageUrl.data}>
											<Button
												size="large"
												icon={<CloseCircleOutlined />}
												style={{ borderRadius: 10, width: '100%' }}
											>
												Batal
											</Button>
										</Link>
									</div>
								</div>
							</Card>
						</Col>

						{/* ===== KOLOM KANAN — Section Cards ===== */}
						<Col xs={24} md={17}>

							{/* SECTION: Akun (hanya saat tambah) */}
							{!isEdit && sectionCard('Akun & Keamanan', <LockOutlined />, '#722ed1',
								<Row gutter={16}>
									<Col xs={24} md={24}>
										<Form.Item
											label="Username"
											name="username"
											rules={[
												{ required: true, message: 'Username wajib diisi' },
												{ pattern: /^[A-Za-z0-9]+$/, message: 'Username hanya boleh huruf dan angka (tanpa spasi, underscore, atau simbol lain)' },
											]}
											hasFeedback
											validateStatus={
												usernameStatus === 'checking'  ? 'validating' :
												usernameStatus === 'available' ? 'success'    :
												usernameStatus === 'taken'     ? 'error'      :
												usernameStatus === 'invalid'   ? 'error'      : ''
											}
											help={
												usernameStatus === 'checking' ? (
													<span style={{ color: '#888' }}>Memeriksa ketersediaan username…</span>
												) : usernameStatus === 'available' ? (
													<span style={{ color: '#52c41a' }}>Username tersedia</span>
												) : usernameStatus === 'invalid' ? (
													<span style={{ color: '#f5222d' }}>{usernameError}</span>
												) : usernameStatus === 'taken' ? (
													<div>
														<div style={{ color: '#f5222d', marginBottom: 8 }}>
															Username sudah digunakan. Coba salah satu saran berikut:
														</div>
														<div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
															{usernameSuggestions.map(s => (
																<Tag
																	key={s}
																	color="blue"
																	style={{ cursor: 'pointer', borderRadius: 20, padding: '2px 10px', fontSize: 12 }}
																	onClick={() => this.useSuggestion(s)}
																>
																	{s}
																</Tag>
															))}
														</div>
													</div>
												) : undefined
											}
										>
											<Input
												prefix={<UserOutlined style={{ color: '#bbb' }} />}
												placeholder="Masukkan username unik (huruf dan angka saja)"
												size="large"
												style={{ borderRadius: 8 }}
												onBlur={(e) => this.checkUsername(e.target.value)}
												onKeyPress={(e) => { if (!/[A-Za-z0-9]/.test(e.key)) e.preventDefault(); }}
												onChange={() => {
													if (this.state.usernameStatus !== 'idle') {
														this.setState({ usernameStatus: 'idle', usernameSuggestions: [], usernameError: '' });
													}
												}}
											/>
										</Form.Item>
									</Col>
									<Col xs={24} md={12}>
										<Form.Item
											label="Password"
											name="password"
											rules={[{ required: true, message: 'Password wajib diisi' }]}
											hasFeedback
										>
											<Input.Password
												prefix={<LockOutlined style={{ color: '#bbb' }} />}
												placeholder="Minimal 6 karakter"
												size="large"
												style={{ borderRadius: 8 }}
											/>
										</Form.Item>
									</Col>
									<Col xs={24} md={12}>
										<Form.Item
											label="Konfirmasi Password"
											name="confirm"
											dependencies={['password']}
											hasFeedback
											rules={[
												{ required: true, message: 'Konfirmasi password wajib diisi' },
												({ getFieldValue }) => ({
													validator(_, value) {
														if (!value || getFieldValue('password') === value) return Promise.resolve();
														return Promise.reject(new Error('Password tidak cocok!'));
													},
												}),
											]}
										>
											<Input.Password
												prefix={<LockOutlined style={{ color: '#bbb' }} />}
												placeholder="Ulangi password"
												size="large"
												style={{ borderRadius: 8 }}
											/>
										</Form.Item>
									</Col>
								</Row>
							)}

							{/* SECTION: Informasi Pribadi */}
							{sectionCard('Informasi Pribadi', <IdcardOutlined />, '#1890ff',
								<Row gutter={16}>
									{/* 1. Nama */}
									<Col xs={24} md={24}>
										<Form.Item
											label="Nama Lengkap"
											name="nama"
											rules={[{ required: true, message: 'Nama wajib diisi' }]}
										>
											<Input
												prefix={<UserOutlined style={{ color: '#bbb' }} />}
												placeholder="Masukkan nama lengkap"
												size="large"
												style={{ borderRadius: 8 }}
											/>
										</Form.Item>
									</Col>
									{/* 2. Status Kepegawaian */}
									<Col xs={24} md={12}>
										<Form.Item
											label="Status Kepegawaian"
											name="is_pns"
											rules={[{ required: true, message: 'Pilih status' }]}
										>
											<Select
												placeholder="Pilih status PNS / Non-PNS"
												size="large"
												style={{ borderRadius: 8 }}
												onChange={(val) => {
													this.setState({ is_pns_value: val });
													if (!val) {
														this.formRef.current.setFieldsValue({ nip: '' });
													}
												}}
											>
												<Select.Option value={true}>PNS</Select.Option>
												<Select.Option value={false}>Non-PNS</Select.Option>
											</Select>
										</Form.Item>
									</Col>
									{/* 3. NIP — hanya muncul jika PNS */}
									{is_pns_value === true && (
										<Col xs={24} md={12}>
											<Form.Item
												label="NIP"
												name="nip"
												rules={[
													{ required: true, message: 'NIP wajib diisi' },
													{ pattern: /^\d+$/, message: 'NIP hanya boleh angka' },
												]}
											>
												<Input
													prefix={<IdcardOutlined style={{ color: '#bbb' }} />}
													placeholder="Masukkan nomor NIP"
													size="large"
													style={{ borderRadius: 8 }}
													maxLength={20}
													onKeyPress={(e) => { if (!/\d/.test(e.key)) e.preventDefault(); }}
												/>
											</Form.Item>
										</Col>
									)}
									{/* 4. No. HP */}
									<Col xs={24} md={12}>
										<Form.Item
											label="No. HP / WhatsApp"
											name="no_hp"
											rules={[
												{ required: true, message: 'No. HP wajib diisi' },
												{ pattern: /^\d+$/, message: 'No. HP hanya boleh angka' },
											]}
										>
											<Input
												prefix={<PhoneOutlined style={{ color: '#bbb' }} />}
												placeholder="contoh: 08123456789"
												size="large"
												style={{ borderRadius: 8 }}
												maxLength={15}
												onKeyPress={(e) => { if (!/\d/.test(e.key)) e.preventDefault(); }}
											/>
										</Form.Item>
									</Col>
									{/* 5. Notifikasi Notice */}
									<Col xs={24} md={12}>
										<Form.Item label="Notifikasi Notice" name="is_notice_picker">
											<div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingTop: 6 }}>
												<Switch
													checked={is_notice}
													onChange={(val) => {
														this.setState({ is_notice: val });
														this.formRef.current.setFieldsValue({ is_notice: val });
													}}
												/>
												<Text style={{ color: is_notice ? '#52c41a' : '#aaa' }}>
													{is_notice ? 'Aktif' : 'Tidak Aktif'}
												</Text>
											</div>
										</Form.Item>
										<Form.Item name="is_notice" style={{ display: 'none' }}>
											<Input type="hidden" />
										</Form.Item>
									</Col>
								</Row>
							)}

							{/* SECTION: Jabatan & Penempatan */}
							{sectionCard('Jabatan & Penempatan', <ApartmentOutlined />, '#52c41a',
								<Row gutter={16}>
									<Col xs={24} md={12}>
										<Form.Item
											label="Jabatan"
											name="jabatan"
											rules={[{ required: true, message: 'Jabatan wajib dipilih' }]}
										>
											{this.generateSelect('Jabatan', configClass.apiUrl.jabatan, 'id', 'nama')}
										</Form.Item>
									</Col>
									<Col xs={24} md={12}>
										<Form.Item
											label="Bidang"
											name="bidang"
											rules={[{ required: true, message: 'Bidang wajib dipilih' }]}
										>
											{this.generateSelect('Bidang', configClass.apiUrl.bidang, 'id', 'nama')}
										</Form.Item>
									</Col>
									<Col xs={24} md={12}>
										<Form.Item
											label="Kabupaten"
											name="kabupaten"
											rules={[{ required: true, message: 'Kabupaten wajib dipilih' }]}
										>
											{this.generateSelect(
												'Kabupaten',
												configClass.apiUrl.kabupaten,
												'id', 'name', '',
												{ onChange: this.handleKabupatenChange },
											)}
										</Form.Item>
									</Col>
									<Col xs={24} md={12}>
										<Form.Item
											label="UPT"
											name="upt"
											rules={[{ required: true, message: 'UPT wajib dipilih' }]}
											extra={!this.state.selectedKabupaten ? (
												<span style={{ fontSize: 12, color: '#faad14' }}>
													Pilih kabupaten terlebih dahulu
												</span>
											) : null}
										>
											{this.generateSelect(
												'Upt',
												configClass.apiUrl.upt,
												'id', 'nama', '',
												{
													disabled: !this.state.selectedKabupaten,
													placeholder: this.state.selectedKabupaten
														? 'Cari / Pilih UPT'
														: 'Pilih kabupaten dahulu',
												},
												this.state.selectedKabupaten
													? 'kabupaten=' + this.state.selectedKabupaten
													: '',
											)}
										</Form.Item>
									</Col>
								</Row>
							)}

							{/* SECTION: Akses & Konfigurasi */}
							{sectionCard('Akses & Konfigurasi', <SafetyOutlined />, '#fa8c16',
								<Row gutter={16}>
									<Col xs={24} md={12}>
										<Form.Item
											label="Level User"
											name="level_user"
											rules={[{ required: true, message: 'Level user wajib dipilih' }]}
										>
											<Select
												placeholder="Pilih level akses"
												size="large"
												style={{ borderRadius: 8 }}
												onChange={(val) => this.setState({ previewLevel: val })}
											>
												<Select.Option value={1}>
													<Tag color="#f5222d" style={{ marginRight: 6 }}>SA</Tag> Superadmin
												</Select.Option>
												<Select.Option value={2}>
													<Tag color="#1890ff" style={{ marginRight: 6 }}>AD</Tag> Admin
												</Select.Option>
												<Select.Option value={3}>
													<Tag color="#52c41a" style={{ marginRight: 6 }}>US</Tag> User
												</Select.Option>
											</Select>
										</Form.Item>
									</Col>
									<Col xs={24} md={12}>
										<Form.Item
											label="Cakupan User"
											name="cakupan_user"
											rules={[{ required: true, message: 'Cakupan wajib dipilih' }]}
										>
											<Select
												placeholder="Pilih cakupan wilayah"
												size="large"
												style={{ borderRadius: 8 }}
											>
												<Select.Option value={1}>
													<BankOutlined style={{ marginRight: 6 }} /> Bapenda
												</Select.Option>
												<Select.Option value={2}>
													<EnvironmentOutlined style={{ marginRight: 6 }} /> Kabupaten
												</Select.Option>
												<Select.Option value={3}>
													<SettingOutlined style={{ marginRight: 6 }} /> UPT
												</Select.Option>
											</Select>
										</Form.Item>
									</Col>

									<Col xs={24}>
										<div style={{
											background: '#fff7e6',
											border: '1px solid #ffd591',
											borderRadius: 10,
											padding: '12px 16px',
											fontSize: 13,
											color: '#874d00',
											lineHeight: 1.6,
										}}>
											<strong>Keterangan Level:</strong>
											<ul style={{ margin: '6px 0 0', paddingLeft: 20 }}>
												<li><Tag color="#f5222d">Superadmin</Tag> — Akses penuh ke seluruh sistem</li>
												<li><Tag color="#1890ff">Admin</Tag> — Akses manajemen data dan laporan</li>
												<li><Tag color="#52c41a">User</Tag> — Akses operasional harian saja</li>
											</ul>
										</div>
									</Col>
								</Row>
							)}

						</Col>
					</Row>
				</Form>
			</div>
		);
	}
}

const mapStateToProps = state => state.configReducers;

export default connect(
	mapStateToProps,
	{ initHandler, setConfig, ajaxViewHandler, ajaxHandler }
)(FormPegawai);
